import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import routeDetails from 'app/constants/routeDetails';
import { viewports } from 'app/constants/breakpoints';
import strings from 'app/locales/home';
import heroCtaImage1Sm from 'app/images/prick_HMPG_header_image_06_600M.jpg';
import heroCtaImage1Md from 'app/images/prick_HMPG_header_image_06_1000.jpg';
import heroCtaImage1Lg from 'app/images/prick_HMPG_header_image_06_1400.jpg';
import heroCtaImage2Sm from 'app/images/prick_HMPG_header_image_01_600M.jpg';
import heroCtaImage2Md from 'app/images/prick_HMPG_header_image_01_1000.jpg';
import heroCtaImage2Lg from 'app/images/prick_HMPG_header_image_01_1400.jpg';
import heroCtaImage3Sm from 'app/images/prick_HMPG_header_image_04_600M.jpg';
import heroCtaImage3Md from 'app/images/prick_HMPG_header_image_04_1000.jpg';
import heroCtaImage3Lg from 'app/images/prick_HMPG_header_image_04_1400.jpg';
import heroCtaImage4Sm from 'app/images/prick_HMPG_header_image_03_600M.jpg';
import heroCtaImage4Md from 'app/images/prick_HMPG_header_image_03_1000.jpg';
import heroCtaImage4Lg from 'app/images/prick_HMPG_header_image_03_1400.jpg';
import heroCtaImage5Sm from 'app/images/prick_HMPG_header_image_02_600M.jpg';
import heroCtaImage5Md from 'app/images/prick_HMPG_header_image_02_1000.jpg';
import heroCtaImage5Lg from 'app/images/prick_HMPG_header_image_02_1400.jpg';
import textBlockBgImage from 'app/images/text-block-bg.png';
import quoteImageSm from 'app/images/prick_HMPG_ashley_image_600M.jpg';
import quoteImageMd from 'app/images/prick_HMPG_ashley_image_1000.jpg';
import quoteImageLg from 'app/images/prick_HMPG_ashley_image_1400.jpg';
import piggyBackImageSm from 'app/images/prick_HMPG_survey_image_600M.jpg';
import piggyBackImageMd from 'app/images/prick_HMPG_survey_image_1000.jpg';
import piggyBackImageLg from 'app/images/prick_HMPG_survey_image_1400.jpg';

import { Actions } from 'app/redux/ui/home/actions';
import { Actions as NavigationActions } from 'app/redux/navigation/actions';
import Selectors from 'app/redux/ui/home/selectors';

import HeroCta from 'app/components/HeroCta';
import Quote from 'app/components/Quote';
import TextBlock from 'app/components/TextBlock';

import styles from './styles.css';

class Home extends PureComponent {
  componentDidMount() {
    const { initialize } = this.props;

    initialize();
  }

  heroImageSizeMap = {
    [viewports.SMALL]: [
      heroCtaImage1Sm,
      heroCtaImage2Sm,
      heroCtaImage3Sm,
      heroCtaImage4Sm,
      heroCtaImage5Sm,
    ],
    [viewports.MEDIUM]: [
      heroCtaImage1Md,
      heroCtaImage2Md,
      heroCtaImage3Md,
      heroCtaImage4Md,
      heroCtaImage5Md,
    ],
    [viewports.LARGE]: [
      heroCtaImage1Lg,
      heroCtaImage2Lg,
      heroCtaImage3Lg,
      heroCtaImage4Lg,
      heroCtaImage5Lg,
    ],
    [viewports.X_LARGE]: [
      heroCtaImage1Lg,
      heroCtaImage2Lg,
      heroCtaImage3Lg,
      heroCtaImage4Lg,
      heroCtaImage5Lg,
    ],
  };

  getRandomHero = () => {
    const { viewport } = this.props;
    const heroOptions = this.heroImageSizeMap[viewport];

    const randomNumber = Math.floor(Math.random() * heroOptions.length);

    return heroOptions[randomNumber];
  };

  render() {
    const { dispatchNavigateToQuestions, viewport } = this.props;
    const heroImage = this.getRandomHero();

    return (
      <div className={styles.container}>
        <HeroCta
          image={heroImage}
          onCtaClick={dispatchNavigateToQuestions}
          ctaLabel={strings.takeTheSurvey}
          title={strings.findOutIfYoureDatingAPrickIn20Questions}
        />
        <TextBlock image={textBlockBgImage} copy={strings.introduction} />
        <Quote
          attribute={strings.reviewName}
          image={[quoteImageSm, quoteImageMd, quoteImageLg]}
          quote={strings.reviewQuote}
          viewport={viewport}
        />
        <HeroCta
          image={[piggyBackImageSm, piggyBackImageMd, piggyBackImageLg]}
          onCtaClick={dispatchNavigateToQuestions}
          ctaLabel={strings.takeTheSurvey}
          title={strings.increaseYourOdds}
        />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  dispatchNavigateToQuestions: () =>
    dispatch(NavigationActions.navigateTo(routeDetails.QUESTIONS.url)),
  initialize: () => dispatch(Actions.initialize()),
});

export default connect(
  Selectors,
  mapDispatchToProps
)(Home);



// WEBPACK FOOTER //
// ./src/routes/Home/index.js